import Marquee from "react-fast-marquee";

export const Ribbon = () => {
  const items = [
    "Armocromia",
    "Body Shape",
    "Restyling Guardaroba",
    "Riorganizzazione Armadio",
    "Accompagnamento Shopping",
    "Percorso Guardaroba",
    "Percorso Shopping",
    "Percorso Evolution",
  ];
  return (
    <div className="bg-espresso py-5 sm:py-6 border-y border-espresso" data-testid="marquee-ribbon">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-item text-crema text-3xl sm:text-5xl px-8">{it}</span>
            <span className="text-fuchsiabrand text-2xl sm:text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
